import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  saveLoading: false,
  foulTypeLength: 0,
  foulType: [],
  foulTypeError: "",
  formError: "",
};

export default function FoulTypeReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_FOUL_TYPE:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_FOUL_TYPE:
      return { ...state, saveLoading: action.payload };
    case actions.GET_FOUL_TYPE:
      return {
        ...state,
        foulType: action.payload.foulType,
        foulTypeLength: action.payload.foulTypeLength,
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.FOUL_TYPE_FAIL:
      return { ...state, foulTypeError: action.payload };
    default:
      return state;
  }
}
